import * as yup from "yup";
import { FormProps } from "react-bootstrap";
import { Assign, ObjectShape } from "yup/lib/object";
import { RequiredStringSchema } from "yup/lib/string";
import { AnyObject } from "yup/lib/types";
import { Asserts } from "yup/lib/util/types";
import { OutageViewModel } from "../../api/generated/models";
import { ESearchWizardSteps } from "../../shared/enums/search.enums";
import { ClickEvent } from "../../shared/types/event.types";
import { ITestableComponentProps } from "../../shared/types/testing.types";
import { IImageUploadState } from "../../state-management/slices/outages/outages.slice";
import { ReactNode } from "react";

export type PinModeSchemaType = yup.ObjectSchema<
  Assign<
    ObjectShape,
    {
      outageFormName: RequiredStringSchema<string | undefined, AnyObject>;
      outageFormPhone: RequiredStringSchema<string | undefined, AnyObject>;
      outageFormEmail: RequiredStringSchema<string | undefined, AnyObject>;
      outageFormComments: yup.StringSchema<string | undefined, AnyObject>;
      outageFormDropdown: RequiredStringSchema<string | undefined, AnyObject>;
      outageFormBracketType: RequiredStringSchema<
        string | undefined,
        AnyObject
      >;
    }
  >
>;

export type OutageSchemaType = yup.ObjectSchema<
  Assign<
    ObjectShape,
    {
      outageFormName: RequiredStringSchema<string | undefined, AnyObject>;
      outageFormPhone: RequiredStringSchema<string | undefined, AnyObject>;
      outageFormEmail: RequiredStringSchema<string | undefined, AnyObject>;
      outageFormComments: yup.StringSchema<string | undefined, AnyObject>;
      outageFormDropdown: RequiredStringSchema<string | undefined, AnyObject>;
    }
  >
>;

export type SearchSchemaType = yup.ObjectSchema<
  Assign<
    ObjectShape,
    { searchFormText: RequiredStringSchema<string | undefined, AnyObject> }
  >
>;

export interface IFormValues {
  outageFormDropdown: string;
  outageFormComments: string;
  outageFormName: string;
  outageFormPhone: string;
  outageFormEmail: string;
  outageFormBracketType: string;
}

export interface ISearchFormValues {
  searchFormText: string;
}
export interface IAcceptOutageValues {
  acceptOutageFormGISID?: number;
}

export interface IOutageSearchProps extends ITestableComponentProps {
  onClose: (event: ClickEvent) => void;
  activeView: "search" | "results" | "detail";
  testid?: string;
}

export interface IOutageSearchFormProps
  extends ITestableComponentProps,
    FormProps {
  onClose: (event: ClickEvent) => void;
  testid?: string;
}

export interface IOutageSearchResultsProps
  extends ITestableComponentProps,
    FormProps {
  onClose: (event: ClickEvent) => void;
  testid?: string;
}

export interface IOutageFormProps extends ITestableComponentProps, FormProps {
  onClose: (event: ClickEvent) => void;
  renderOptions?: (outageReasons: Array<string>) => ReactNode | null;
}

export interface IFormConfirmationProps {
  submittedOutage: OutageViewModel | null;
  imageUploadState: IImageUploadState;
  onClose: (event: ClickEvent) => void;
}

// Default Props
export const DefaultOutageSearchProps: IOutageSearchProps = {
  activeView: ESearchWizardSteps.SEARCH,
  onClose: () => null,
  testid: "outage-search",
};

export const DefaultOutageSearchFormProps: IOutageSearchFormProps = {
  onClose: () => null,
  testid: "outage-search-form",
};

export const DefaultOutageSearchResultsProps: IOutageSearchResultsProps = {
  onClose: () => null,
  testid: "outage-search-form-results",
};
